module.exports = "./img/a869465c7224c5f29a3a0050190263dd.jpg";